import { render, staticRenderFns } from "./editSnake.vue?vue&type=template&id=5731cd91"
import script from "./editSnake.vue?vue&type=script&lang=js"
export * from "./editSnake.vue?vue&type=script&lang=js"
import style0 from "./editSnake.vue?vue&type=style&index=0&id=5731cd91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports